<template>
<div class="chapter">
<div class="inner_page">
      ﻿<title>His Love Endures Forever: A Land of Canaan Novel</title>
<link href="default.css" rel="stylesheet" type="text/css"/>
<meta charset="utf-8"/>
<p class="ct" id="d7e9819"><span>Contents</span></p>
<p class="cct" id="d7e1039"><span><a href="#/chapter2" id="d6e2">Pennsylvania Dutch Glossary</a></span></p>
<p class="cct" id="d7e9899"><span><a href="#/chapter3" id="d6e3">One</a></span></p>
<p class="cct" id="d7e9929"><span><a href="#/chapter4" id="d6e4">Two</a></span></p>
<p class="cct" id="d7e9979"><span><span href="#/chapter5" id="d6e5" title="Link target outside of Sample">Three</span></span></p>
<p class="cct" id="d7e10009"><span><span href="#/chapter6" id="d6e6" title="Link target outside of Sample">Four</span></span></p>
<p class="cct" id="d7e10049"><span><span href="#/chapter7" id="d6e7" title="Link target outside of Sample">Five</span></span></p>
<p class="cct" id="d7e10079"><span><span href="#/chapter8" id="d6e8" title="Link target outside of Sample">Six</span></span></p>
<p class="cct" id="d7e10129"><span><span href="#/chapter9" id="d6e9" title="Link target outside of Sample">Seven</span></span></p>
<p class="cct" id="d7e10159"><span><span href="#/chapter10" id="d6e10" title="Link target outside of Sample">Eight</span></span></p>
<p class="cct" id="d7e10199"><span><span href="#/chapter11" id="d6e11" title="Link target outside of Sample">Nine</span></span></p>
<p class="cct" id="d7e10249"><span><span href="#/chapter12" id="d6e12" title="Link target outside of Sample">Ten</span></span></p>
<p class="cct"><span><span href="#/chapter13" id="d6e121" title="Link target outside of Sample">Eleven</span></span></p>
<p class="cct"><span><span href="#/chapter14" id="d6e122" title="Link target outside of Sample">Twelve</span></span></p>
<p class="cct"><span><span href="#/chapter15" id="d6e123" title="Link target outside of Sample">Thirteen</span></span></p>
<p class="cct"><span><span href="#/chapter16" id="d6e124" title="Link target outside of Sample">Fourteen</span></span></p>
<p class="cct"><span><span href="#/chapter17" id="d6e125" title="Link target outside of Sample">Fifteen</span></span></p>
<p class="cct"><span><span href="#/chapter18" id="d6e126" title="Link target outside of Sample">Sixteen</span></span></p>
<p class="cct"><span><span href="#/chapter19" id="d6e127" title="Link target outside of Sample">Seventeen</span></span></p>
<p class="cct"><span><span href="#/chapter20" id="d6e128" title="Link target outside of Sample">Eighteen</span></span></p>
<p class="cct"><span><span href="#/chapter21" id="d6e129" title="Link target outside of Sample">Nineteen</span></span></p>
<p class="cct"><span><span href="#/chapter22" id="d6e1210" title="Link target outside of Sample">Twenty</span></span></p>
<p class="cct"><span><span href="#/chapter23" id="d6e1211" title="Link target outside of Sample">Twenty-One</span></span></p>
<p class="cct"><span><span href="#/chapter24" id="d6e1212" title="Link target outside of Sample">Twenty-Two</span></span></p>
<p class="cct"><span><span href="#/chapter25" id="d6e1213" title="Link target outside of Sample">Twenty-Three</span></span></p>
<p class="cct"><span><span href="#/chapter26" id="d6e1214" title="Link target outside of Sample">Twenty-Four</span></span></p>
<p class="cct"><span><span href="#/chapter27" id="d6e1215" title="Link target outside of Sample">Reading Group Guide</span></span></p>
<p class="cct"><span><span href="#/chapter28" id="d6e1216" title="Link target outside of Sample">Amish Recipes</span></span></p>
<p class="cct" id="d7e10279"><span><span href="#/chapter29" id="d6e13" title="Link target outside of Sample">Acknowledgments </span></span></p>
<p class="cct" id="d7e10279a"><span><span href="#/chapter1#bb_2" id="aa_2" title="Link target outside of Sample">An Excerpt from <i>Need You Now</i></span></span></p>
<p class="cct" id="d7e10319"><span><span href="#/chapter1a" id="d6e15" title="Link target outside of Sample">About the Author</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1d.vue?494ac5e2